import type { Icon } from '@awork/_shared/static-data/icons'
import type { LucideIcon } from '@awork/_shared/directives/icons/types'
import { DestroyRef, Directive, inject, input, output } from '@angular/core'
import { TabBarActionService } from '../../services/tab-bar-action-service/tab-bar-action.service'
import { HapticService } from '../../../shared/services/haptic-service/haptic.service'

/** Supplies a page-owned action without rendering a second button. */
@Directive({ selector: '[awTabBarAction]' })
export class TabBarActionDirective {
  private readonly actions = inject(TabBarActionService)
  private readonly hapticService = inject(HapticService)
  private readonly destroyRef = inject(DestroyRef)

  readonly awTabBarAction = input.required<string>()
  readonly actionDisabled = input(false)
  readonly actionIcon = input<Icon | LucideIcon>('add')
  readonly icon = this.actionIcon
  readonly label = this.awTabBarAction
  readonly disabled = this.actionDisabled
  readonly actionPressed = output<void>()

  constructor() {
    this.actions.register(this)
    this.destroyRef.onDestroy(() => this.actions.unregister(this))
  }

  /** Runs the existing page action with tap feedback when it is enabled. */
  press(): void {
    if (this.disabled()) {
      return
    }

    this.hapticService.buttonClick()
    this.actionPressed.emit()
  }
}
